/**
 * @generated SignedSource<<e56eb2ac0a21dabecf8f531e45c7238d>>
 * @relayHash c530bd47c3fdfcbed4bfc9eeb125b072
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c520d242c1d304585ff4ba5cdf4a7d196bf336587e83c24b8a617fe4ef0494b2

import type { ConcreteRequest } from 'relay-runtime';
export type agentSessionHydrationQuery$variables = {
  aqlQuery: string;
  sharingContext: string;
};
export type agentSessionHydrationQuery$data = {
  readonly agent_sessionQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly agentAccountId: string | null;
      readonly associatedEntities: ReadonlyArray<{
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "JiraIssue";
        readonly id: string;
        readonly key: string;
        readonly webUrl: AGG$URL | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null> | null;
      readonly author: {
        readonly accountId: string;
        readonly name: string;
      } | null;
      readonly conversationChannel: {
        readonly createdAt: AGG$Long | null;
        readonly id: string | null;
        readonly interactionChannel: string | null;
        readonly interactionChannelAri: string | null;
        readonly isPinned: boolean | null;
        readonly isPlanning: boolean | null;
        readonly lastAgentMessageId: string | null;
        readonly lastAgentMessageStatus: string | null;
        readonly lastMessage: string | null;
        readonly lastMessageTimestamp: AGG$Long | null;
        readonly lastMessageType: ReadonlyArray<string | null> | null;
        readonly name: string | null;
        readonly pinnedAt: AGG$Long | null;
        readonly readStatus: boolean | null;
        readonly status: string | null;
      } | null;
      readonly convoAiAgentId: string | null;
      readonly expireTime: AGG$DateTime | null;
      readonly hasUnseenActivity: boolean | null;
      readonly id: string | null;
      readonly invocationType: string | null;
      readonly isRovo: boolean | null;
      readonly lastStateChangeAt: AGG$Long | null;
      readonly state: string | null;
      readonly stateReason: string | null;
      readonly studioAgent: {
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type agentSessionHydrationQuery = {
  response: agentSessionHydrationQuery$data;
  variables: agentSessionHydrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharingContext"
},
v2 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "hasUnseenActivity"
},
v4 = {
  "kind": "ScalarField",
  "name": "invocationType"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "state"
},
v7 = {
  "kind": "ScalarField",
  "name": "stateReason"
},
v8 = {
  "kind": "ScalarField",
  "name": "expireTime"
},
v9 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v10 = {
  "kind": "ScalarField",
  "name": "isRovo"
},
v11 = {
  "kind": "ScalarField",
  "name": "agentAccountId"
},
v12 = {
  "kind": "ScalarField",
  "name": "convoAiAgentId"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "alias": "conversationChannel",
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "nativeConversationChannel",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "createdAt"
    },
    {
      "kind": "ScalarField",
      "name": "interactionChannel"
    },
    {
      "kind": "ScalarField",
      "name": "interactionChannelAri"
    },
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastMessage"
    },
    {
      "kind": "ScalarField",
      "name": "lastMessageTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "lastMessageType"
    },
    {
      "kind": "ScalarField",
      "name": "lastAgentMessageId"
    },
    {
      "kind": "ScalarField",
      "name": "lastAgentMessageStatus"
    },
    {
      "kind": "ScalarField",
      "name": "readStatus"
    },
    {
      "kind": "ScalarField",
      "name": "isPlanning"
    },
    {
      "kind": "ScalarField",
      "name": "isPinned"
    },
    {
      "kind": "ScalarField",
      "name": "pinnedAt"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "kind": "ScalarField",
  "name": "picture"
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraIssue"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "base"
        },
        {
          "kind": "ScalarField",
          "name": "webUi"
        }
      ]
    }
  ],
  "type": "ConfluencePage"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "agentSessionHydrationQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "studioAgent",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "agentSessionHydrationQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "studioAgent",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v13/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c520d242c1d304585ff4ba5cdf4a7d196bf336587e83c24b8a617fe4ef0494b2",
    "metadata": {},
    "name": "agentSessionHydrationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dd9fb992b06d9964d76c48b2feda8674";

export default node;
